import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../pages/Pages.css';
import { newsService } from '../services/newsService';
import { formatDateEST } from '../utils/timezoneUtils';

function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPublishedNews();
  }, []);

  const fetchPublishedNews = async () => {
    try {
      setLoading(true);
      const result = await newsService.getPublishedNews();
      if (result.success) {
        setArticles(result.news);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Failed to load news');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const extractFirstImage = (content) => {
    try {
      const parsed = JSON.parse(content);
      if (Array.isArray(parsed)) {
        const imageBlock = parsed.find(b => b.type === 'image' && b.src);
        if (imageBlock?.src) {
          return imageBlock.src;
        }
      }
    } catch (e) {
      const match = content.match(/<img[^>]+src="([^">]+)"/);
      return match ? match[1] : null;
    }
    return null;
  };

  const stripHtmlAndTrim = (content, length = 150) => {
    try {
      const parsed = JSON.parse(content);
      if (Array.isArray(parsed)) {
        const textBlocks = parsed.filter(b => b.type === 'text');
        const text = textBlocks.map(b => b.content).join(' ');
        return text.length > length ? text.substring(0, length) + '...' : text;
      }
    } catch (e) {
      const text = content.replace(/<[^>]*>/g, '');
      return text.length > length ? text.substring(0, length) + '...' : text;
    }
  };

  if (loading) {
    return (
      <div className="page">
        <h1>News</h1>
        <p>Loading news...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page">
        <h1>News</h1>
        <p style={{ color: 'red' }}>Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="page news-page">
      <h1>News</h1>
      {articles.length === 0 ? (
        <p>No news articles available at this time.</p>
      ) : (
        <div className="news-feed">
          {articles.map((article) => {
            const imageUrl = article.header_image || extractFirstImage(article.content);
            return (
              <Link 
                key={article.id}
                to={`/news/${article.id}`}
                className="news-card"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="news-card-image">
                  {imageUrl ? (
                    <img src={imageUrl} alt={article.title} />
                  ) : (
                    <div className="news-card-placeholder">No image</div>
                  )}
                </div>
                <div className="news-card-content">
                  <h3 className="news-card-title">{article.title}</h3>
                  <p className="news-card-excerpt">{stripHtmlAndTrim(article.content)}</p>
                  <div className="news-card-footer">
                    <div className="news-card-authors">
                      <span className="news-card-written">✍️ {article.created_by_name || article.author_name}</span>
                      {article.published_by_name && (
                        <span className="news-card-published">📤 {article.published_by_name}</span>
                      )}
                    </div>
                    <span className="news-card-date">
                      {formatDateEST(article.published_at)}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default News;
